module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1510-9e04a7bddd8650d6b17cd84f47023a40.png";